import useVhsNodesStore from '@/common/store/pinia/vhsNodes';

const fetchVhsNodeName = async (nodeId: string): Promise<string> => {
  try {
    const vhsNodesStore = useVhsNodesStore();
    let node = vhsNodesStore.getItemById(nodeId);
    if (!node) {
      await vhsNodesStore.fetchItem(nodeId);
      node = vhsNodesStore.getItemById(nodeId);
    }
    return node?.name || '';
  } catch (error) {
    console.error(`Failed to fetch VHS node with ID ${nodeId}:`, error);
    return '';
  }
};

export default fetchVhsNodeName;
